"use client";

import Link from "next/link";
import { useCallback, useState } from "react";
import { FaRepeat } from "react-icons/fa6";
import Logo from "./Logo";
import { ExtendedSubscription, SimplifiedUser } from "@/app/types";
import { SessionProvider } from "next-auth/react";
import UserMenu from "./UserMenu";

interface NavbarProps {
  simplifiedUser?: SimplifiedUser | null;
}

const Navbar: React.FC<NavbarProps> = ({
  simplifiedUser,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prev) => !prev);
    setIsUserMenuOpen(false);
  }, []);

  const toggleUserMenu = useCallback(() => {
    setIsUserMenuOpen((prev) => !prev);
    setIsMenuOpen(false);
  }, []);

  return (
    <nav className="bg-gray-900 border-b border-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <Link
              href="/"
              className="ml-2 text-2xl font-bold font-mono text-white"
            >
              <Logo />
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-8 font-semibold">
            <Link href="/#pricing" className="text-white hover:text-emerald-400">
              Pricing
            </Link>
            <Link href="/#demo" className="text-white hover:text-emerald-400">
              Demo
            </Link>
            <a
              href="https://x.com/eliana_jordan"
              className="text-white hover:text-emerald-400"
            >
              Contact
            </a>
            <UserMenu
              currentUser={simplifiedUser}
              isOpen={isUserMenuOpen}
              toggleOpen={toggleUserMenu}
            />
          </div>

          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMenu}
              className="text-white hover:text-emerald-400 sm:mr-0 mr-2"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            </button>
            <UserMenu
              currentUser={simplifiedUser}
              isOpen={isUserMenuOpen}
              toggleOpen={toggleUserMenu}
            />
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-gray-900 border-t border-gray-800">
          <div className="px-4 pt-4 pb-3 space-y-3 font-semibold">
            <Link
              href="#pricing"
              className="block text-white hover:text-emerald-400"
              onClick={toggleMenu}
            >
              Pricing
            </Link>
            <Link
              href="#demo"
              className="block text-white hover:text-emerald-400"
              onClick={toggleMenu}
            >
              Demo
            </Link>
            <a
              href="https://x.com/eliana_jordan"
              className="block text-white hover:text-emerald-400"
              onClick={toggleMenu}
            >
              Contact
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;